module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/logos/brand/color-dropbox-5e1a43f45cc65fda5e75fa58a4205536.svg";